import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of } from 'rxjs';
import { ApiBanner } from '@e-check/shared';
import { environment } from '../../../environments/environment';
import { BannerService, hasBannerBeenDismissed } from './banner.service';
import { TranslationKey } from '@core/utils/marker';

@Injectable({ providedIn: 'root' })
export class BannerApiService {
  private http = inject(HttpClient);
  private bannerService = inject(BannerService);
  private readonly POLL_INTERVAL = 15 * 60 * 1000;

  readonly rawBanners = signal<ApiBanner[]>([]);

  init(): void {
    this.fetch();
    setInterval(() => this.fetch(), this.POLL_INTERVAL);
  }

  private fetch(): void {
    this.http
      .get<ApiBanner[] | null>(`${environment.apiUrl}/banners`)
      .pipe(catchError(() => of(null)))
      .subscribe((banners) => {
        if (!banners) return;

        this.rawBanners.set(banners);

        for (const banner of banners) {
          if (hasBannerBeenDismissed(banner)) continue;
          if (this.bannerService.isShowing(banner)) continue;

          this.bannerService.show({
            translationKey: banner.translationKey as TranslationKey,
            translationParams: banner.translationParams,
            severity: banner.severity,
            icon: banner.icon,
            iconColor: banner.iconColor,
            closable: banner.closable,
          });
        }
      });
  }
}
